import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link } from "@tanstack/react-router";
import { AppShell } from "@/features/shell/AppShell";
import { errorMessage } from "@/shared/api/client";
import { Empty, ErrorNote } from "@/shared/ui";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: AppShell,
  notFoundComponent: () => (
    <div className="p-7">
      <Empty
        title="没有这个页面"
        action={
          <Link to="/" className="underline">
            回到首页
          </Link>
        }
      />
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="p-7">
      <ErrorNote>{errorMessage(error)}</ErrorNote>
    </div>
  ),
});
